import React from "react";
import { Step, Icon } from "semantic-ui-react";
function Wizard({ step }) {
  return (
    <Step.Group widths={3}>
      <Step completed={step > 1} active={step === 1}>
        <Icon name="file outline"></Icon>
        <Step.Content>
          <Step.Title>Choose ANP files</Step.Title>
        </Step.Content>
      </Step>
      <Step completed={step > 2} active={step === 2}>
        <Icon name="edit outline"></Icon>
        <Step.Content>
          <Step.Title>Set Parameters</Step.Title>
        </Step.Content>
      </Step>
      <Step completed={step > 3} active={step === 3}>
        <Icon name="cloud download"></Icon>
        <Step.Content>
          <Step.Title>Download LINKPlanner File</Step.Title>
        </Step.Content>
      </Step>
    </Step.Group>
  );
}

export default Wizard;
